/**
 * Display format options for picker inputs
 *
 * Defines the precision and format of datetime values displayed in the picker.
 * Maps to HTML5 input types and determines conversion behavior.
 */
export type PickerDisplayFormat = 'date' | 'datetime-hm' | 'datetime-hms';

/**
 * Picker display format constants
 *
 * @example
 * // For timestamp cells with full precision
 * displayFormat: PickerDisplayFormat.DateTimeHoursMinutesSeconds
 *
 * @example
 * // For collect cells with minute precision
 * displayFormat: PickerDisplayFormat.DateTimeHoursMinutes
 */
export const PickerDisplayFormat = {
  /** Date only: 2024-02-15 */
  Date: 'date',
  /** DateTime with hours and minutes: 2024-02-15T10:30 */
  DateTimeHoursMinutes: 'datetime-hm',
  /** DateTime with hours, minutes, and seconds: 2024-02-15T10:30:45 */
  DateTimeHoursMinutesSeconds: 'datetime-hms',
} as const satisfies Record<string, PickerDisplayFormat>;
